module.exports = __webpack_public_path__ + "static/media/logo_rancagua.48a757eb.png";